
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";
import { trackTripCardAction } from "@/utils/analytics";

export const useTaxiData = (tripId: string, destinationName: string) => {
  const [showTaxi, setShowTaxi] = useState(false);
  const { toast } = useToast();
  const { t } = useTranslation();

  const handleTaxiClick = async () => {
    try {
      setShowTaxi(true);
      trackTripCardAction("taxi", tripId, destinationName);
      toast({
        description: "Taxi transfer booking feature coming soon!"
      });
    } catch (error) {
      console.error('Error handling taxi:', error);
      toast({
        variant: "destructive",
        description: "An error occurred while fetching taxi data"
      });
    }
  };

  return {
    showTaxi,
    setShowTaxi,
    handleTaxiClick
  };
};
